import { Injectable } from '@rxdi/core';
import CodeMirror from 'codemirror';

@Injectable()
export class EditorProvider {
  private codeMirror: CodeMirror.Editor;

  getInstance() {
    return this.codeMirror;
  }

  setInstance(mirror: CodeMirror.Editor) {
    this.codeMirror = mirror;
  }
}
